import { lazyWithPreload } from 'react-lazy-with-preload';

const AwsIntegrationListPage = lazyWithPreload(() => import('./pages/aws-integration-list/Page'));
const AzureIntegrationListPage = lazyWithPreload(() => import('./pages/azure-integration-list/Page'));
const OracleIntegrationListPage = lazyWithPreload(() => import('./pages/oracle-integration-list/Page'));
const FTPServerIntegrationListPage = lazyWithPreload(() => import('./pages/ftp-server-integration-list/Page'));
const DropboxIntegrationListPage = lazyWithPreload(() => import('./pages/dropbox-integration-list/Page'));
const DropboxAuthorizationPage = lazyWithPreload(() => import('./pages/dropbox-authorization/Page'));
const PhotoSentinelIntegrationPage = lazyWithPreload(() => import('./pages/photo-sentinel-list/page'));
// const DropboxRedirectPage = lazyWithPreload(() => import('./pages/dropbox-inte gration-list/DropboxRedirectPage'));

const Routes = [
    {
        path: 'projects/:projectId/cameras/:cameraId/integrations/aws',
        element: <AwsIntegrationListPage />,
    },
    {
        path: 'projects/:projectId/cameras/:cameraId/integrations/azure',
        element: <AzureIntegrationListPage />,
    },
    {
        path: 'projects/:projectId/cameras/:cameraId/integrations/dropbox',
        element: <DropboxIntegrationListPage />,
    },
    {
        path: 'dropbox-authorization',
        element: <DropboxAuthorizationPage />,
    },
    {
        path: 'projects/:projectId/cameras/:cameraId/integrations/oracle',
        element: <OracleIntegrationListPage />,
    },
    {
        path: 'projects/:projectId/cameras/:cameraId/integrations/ftp-server',
        element: <FTPServerIntegrationListPage />,
    },
    {
        path: 'projects/:projectId/cameras/:cameraId/integrations/ftp-server',
        element: <FTPServerIntegrationListPage />,
    },

    {
        path: 'projects/:projectId/cameras/:cameraId/integrations/photo-sentinel',
        element: <PhotoSentinelIntegrationPage />,
    },
];

export default Routes;
